var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fieldBorderCss, fieldCss } from '@atomic/obj.form/field.component.styled';
export var TextAreaStyled = styled.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  min-height: 100px;\n  max-width: 100%;\n"], ["\n  ", "\n  ", "\n  min-height: 100px;\n  max-width: 100%;\n"])), fieldBorderCss, fieldCss);
var templateObject_1;
